import { render } from "./FlippingWords.vue?vue&type=template&id=58540484&scoped=true"
import script from "./FlippingWords.vue?vue&type=script&lang=js"
export * from "./FlippingWords.vue?vue&type=script&lang=js"

import "./FlippingWords.vue?vue&type=style&index=0&id=58540484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58540484"]])

export default __exports__